import { ImageOrientation } from '@space-core/components/customImage/enum'

import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'

import { focusVisible } from '@space-core/styles'
import styled from 'styled-components'

import ProductCardMobileDefault from '../mobileDefault'
import type { ProductCardProps } from '../types'

import '@hotmart/cosmos/dist/styles/utilities/text/variations/green.css'

const ProductTitleVertical = styled.h3`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-break: auto;
`

const ProductButton = styled.button<{
  isCarousel?: boolean
  imageOrientation?: ImageOrientation
  mobileVerticalViewMin?: boolean
  isMobile?: boolean
}>`
  background: 0;

  ${focusVisible}
  ${({ isCarousel, imageOrientation, mobileVerticalViewMin, isMobile }) =>
    isCarousel
      ? `
      flex: none;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
      width: ${
        imageOrientation === ImageOrientation.HORIZONTAL
          ? isMobile
            ? '85%'
            : '30.5%'
          : mobileVerticalViewMin
          ? '29.5%'
          : isMobile
          ? '45%'
          : '35%'
      };
      margin-right: var(--spacer-2);

      :first-child {
        margin-left: var(--spacer-2);
      }
  `
      : `
    width: auto
`}
`

const ProductCardMobile = ({
  product,
  handleClick,
  isCarousel,
  containerOrientation,
  imageOrientation,
  mobileVerticalViewMin
}: ProductCardProps) => {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.sm})`)

  return (
    <ProductButton
      data-test='product-btn'
      onClick={handleClick}
      isCarousel={isCarousel}
      isMobile={isMobile}
      imageOrientation={imageOrientation}
      mobileVerticalViewMin={mobileVerticalViewMin}
      className='_border-0 _p-0'
      aria-label='button'>
      <ProductCardMobileDefault
        product={product}
        containerOrientation={containerOrientation}
        imageOrientation={imageOrientation}
      />

      {imageOrientation === ImageOrientation.VERTICAL && (
        <>
          <ProductTitleVertical className='_text-2 _text-gray-900 _font-weight-bold _text-left _mb-1 _mt-2 _pt-1 _pb-0'>
            {product.name}
          </ProductTitleVertical>

          {Boolean(product.price) && !product.isPurchased && (
            <p className='_mt-1 _mb-5 _text-2 _font-weight-bold _text-green _text-left'>
              {product.price}
            </p>
          )}
        </>
      )}
    </ProductButton>
  )
}

export default ProductCardMobile
